


























import Vue from "vue";
import { Tweezer } from "../lib/Tweezer";
import debounce from "lodash-es/debounce";

export default Vue.extend({
  props: {
    id: {
      type: [Number, String],
      default: 1,
      required: true
    },
    max: {
      type: Number,
      default: 100.0
    },
    targetText: {
      type: [String, Number],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    aantal: {
      type: Number,
      default: -1
    },
    target: {
      type: Number,
      default: 0
    },
    showMarker: {
      type: Boolean,
      default: false
    },
    showClosed: {
      type: Boolean,
      default: false
    },
    showAsPercentage: {
      type: Boolean,
      default: true
    },
    showSubAsPercentage: {
      type: Boolean,
      default: false
    },
    dimmed: { type: Boolean, default: false }
  },
  watch: {
    aantal() {
      this.handleUpdate();
    },
    target() {
      this.handleUpdate();
    },
    targetText() {
      this.handleUpdate();
    },
    name() {
      this.handleUpdate();
    }
  },

  data() {
    return {
      backgroundColor: "#f7f7f7",
      successColor: "#85b436",
      closeColor: "#fdbe02", //geel
      warningColor: "red",

      size: 150,
      strokeWidth: 6,

      closeTreshold: 0.9,

      fontFamily: null,
      valueTextColor: "black",
      targetTextColor: "#a0a0a0",

      targetMarkerColor: "rgba(0,0,0,0.25)",

      animate: true,
      LargeFontSizePx: 40,
      LargeFontSizeBaselinePx: 15,
      SmallFontSizePx: 16,
      SmallFontSizeBaselinePx: 6,
      center: 0,
      meterRadius: 0,
      positionValue: 0,
      lastPositionValue: 0,
      lastMaxValue: 0,
      maxValue: 100,
      targetValue: 0,

      styleSVG: {
        display: "block",
        margin: "auto",
        width: "150px",
        height: "150px"
      },
      pathBG: "",
      styleBG: {
        "stroke-width": 5
      },
      styleMeter: {
        "stroke-width": 5,
        "stroke-linecap": "round"
      },
      pathMeter: "",

      styleMarker: {
        visibility: "hidden",
        "stroke-width": 0,
        "stroke-linecap": "round",
        opacity: 1
      },
      pathMarker: "",
      transformMarker: "",
      centerText: "",
      centerTextx: 75,
      centerTexty: 82,
      styleText: {
        "font-size": "40px",
        "text-anchor": "middle",
        "font-family": "clear_sans_thinregular, arial, sans-serif"
      },
      subText: "",
      subTextx: 75,
      subTexty: 105,
      styleSubText: {
        "font-size": "16px",
        "text-anchor": "middle",
        "font-family": "clear_sans_thinregular, arial, sans-serif"
      },
      handleUpdateDebounced: null as any
    };
  },
  computed: {
    ringColor(): string {
      if (this.showClosed) return this.closeColor;

      if (this.showMarker) {
        return this.positionValue >= this.targetValue
          ? this.successColor
          : this.warningColor;
      }

      return this.successColor;
    },
    showSubtext(): boolean {
      return !!this.subText;
    }
  },
  methods: {
    update: function() {
      var maxval = this.max === undefined ? this.aantal : this.max;
      this.maxValue = Math.round(maxval);
      this.positionValue = Math.round(this.aantal);
      this.targetValue = Math.round(this.target);
      if (this.showClosed) {
        this.maxValue = this.positionValue;
      }
      this.updateGaugeStyle();
    },
    handleUpdate: function() {
      if (!this.handleUpdateDebounced) {
        this.handleUpdateDebounced = debounce(() => {
          this.update();
        }, 600);
      }
      this.handleUpdateDebounced();
    },
    updateGaugeStyle: function() {
      // Full circle
      if (!this.pathBG) {
        this.pathBG = this.createArcPath(1, 1, this.meterRadius);
      }

      // If the maxValue changed, scale the lastPositionValue accordingly
      let lastPositionValue = this.lastPositionValue;
      if (this.lastMaxValue > 0 && this.lastMaxValue != this.maxValue)
        lastPositionValue =
          (lastPositionValue / this.lastMaxValue) * this.maxValue;

      this.animator(
        lastPositionValue,
        this.positionValue,
        this.animateArcCallback
      );
      this.lastPositionValue = this.positionValue;
      this.lastMaxValue = this.maxValue;

      // TargetMarker
      let startY =
        Math.round((this.size - this.meterRadius * 2) / 2) -
        this.strokeWidth / 2;
      this.pathMarker =
        "M" +
        this.center +
        "," +
        startY +
        " L" +
        this.center +
        "," +
        (startY + this.strokeWidth * 2);
      // console.log(this.pathMarker);
      this.styleMarker = {
        visibility: this.showMarker ? "visible" : "hidden",
        "stroke-width": this.strokeWidth / 2,
        "stroke-linecap": "round",
        opacity: 0
      };

      this.animator(0, 1, (value: number) => {
        // console.log(value);
        this.styleMarker.opacity = value;
      });

      if (!!this.maxValue && this.maxValue !== 0) {
        this.transformMarker =
          "rotate(" +
          (this.targetValue / this.maxValue) * 360 +
          "," +
          this.center +
          "," +
          this.center +
          ")";
      }

      //tekst
      // Position text
      if (this.positionValue !== null) {
        this.centerTextx = this.center;
        this.centerTexty =
          this.center +
          this.LargeFontSizeBaselinePx -
          (this.targetValue !== 0 ? 8 : 0);

        this.centerText = this.getDisplayValue(this.positionValue);
      }

      // Target text
      this.subText = '';      
      if (this.targetValue !== 0) {
        this.subTextx = this.center;
        this.subTexty = this.center + this.SmallFontSizeBaselinePx + 24;
        this.subText =
          String(this.targetText) + this.getDisplayValueSub(this.targetValue);
      }
    },
    getDisplayValue: function(value: number) {
      if (value == -1) return "...";
      //if (value === 0) return "";
      return Math.round(value).toString() + (this.showAsPercentage ? "%" : "");
    },
    getDisplayValueSub: function(value: number) {
      if (value == -1) return "...";
      //if (value === 0) return "";
      return (
        Math.round(value).toString() + (this.showSubAsPercentage ? "%" : "")
      );
    },
    clicked: function() {
      this.$emit("clicked", this.id);
    },
    animateArcCallback: function(position: number) {
      this.pathMeter = this.createArcPath(
        position,
        this.maxValue,
        this.meterRadius
      );
    },
    animator: function(
      startPosition: number,
      endPosition: number,
      actionCallback: Function
    ) {
      new Tweezer({
        start: startPosition,
        end: endPosition,
        duration: 600
      })
        .on("tick", actionCallback)
        .begin();
    },
    createArcPath: function(value: number, max: number, radius: number) {
      let degrees = max != 0 ? (360 / max) * value : 0;
      let a = ((90 - degrees) * Math.PI) / 180;
      let x = this.center + radius * Math.cos(a);
      let y = this.center - radius * Math.sin(a);

      let path =
        "M" +
        this.center +
        "," +
        (this.center - radius) +
        " A" +
        radius +
        "," +
        radius +
        ",0,";

      if (max == value)
        return (
          path + "1,1 " + (this.center - 0.01) + "," + (this.center - radius)
        );
      else return path + (degrees > 180 ? "1" : "0") + ",1 " + x + "," + y;
    }
  },
  mounted: function() {
    this.styleSVG.width = this.size + "px";
    this.styleSVG.height = this.size + "px";
    this.center = Math.round(this.size / 2);
    this.meterRadius = Math.round((this.size - this.strokeWidth * 2) / 2);
    this.handleUpdate();
  }
});
